import * as React from "react"
import styled from "styled-components"

interface Props {
  read: boolean
}

const Read = styled.div`
  width: 10px;
  height: 10px;
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  background-color: ${(props) => props.theme.colors.greyDark};
  border-radius: 50%;
`

const Unread = styled.div`
  width: 10px;
  height: 10px;
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  border-radius: 50%;
`

const NotificationSymbol: React.FunctionComponent<Props> = ({ read }) => {
  return !read ? <Read /> : <Unread />
}

export default NotificationSymbol
